(() => {
  'use strict';
  const instances = new Map();
  function initialize(scope) {
    scope.querySelectorAll('[data-filters-dialog]').forEach(dialog => {
      if (instances.has(dialog) || typeof dialog.showModal !== 'function') return;
      const page = dialog.closest('.catalog-page');
      const sidebar = page.querySelector('.collection-sidebar');
      const trigger = page.querySelector('[data-filters-open]');
      if (!sidebar?.querySelector('.filter-disclosure')) return;
      const hint = page.querySelector('[data-filters-hint]');
      const hintKey = 'beerclub-filter-hint-seen-v1';
      let hintSeen = false;
      try { hintSeen = sessionStorage.getItem(hintKey) === '1'; } catch { /* Keep the hint usable without storage. */ }
      const names = [...sidebar.querySelectorAll('.filter-disclosure > summary')].map(node => node.textContent.replace(/\s*\(\d+\)\s*$/, '').trim().toLocaleLowerCase('pt-BR')).filter(Boolean).slice(0, 3);
      if (hint && names.length) {
        const options = names.length > 1 ? names.slice(0, -1).join(', ') + ' e ' + names.at(-1) : names[0];
        hint.querySelector('[data-filters-hint-text]').textContent = 'Toque para filtrar por ' + options + '.';
      }
      const count = Number(page.querySelector('[data-active-filters]')?.dataset.activeCount || 0);
      const badge = trigger.querySelector('[data-filters-count]');
      if (badge && count > 0) {
        badge.querySelector('[data-filters-count-value]').textContent = String(count);
        badge.hidden = false;
      }
      function syncHint() {
        if (!hint) return;
        hint.hidden = !mobile.matches || hintSeen;
        if (hint.hidden) trigger.removeAttribute('aria-describedby');
        else trigger.setAttribute('aria-describedby', hint.id);
      }
      const home = sidebar.parentElement;
      const anchor = document.createComment('Collection filters');
      sidebar.before(anchor);
      const mobile = window.matchMedia('(max-width: 700px)');
      function sync() {
        if (dialog.open) dialog.close();
        if (mobile.matches) dialog.querySelector('[data-filters-slot]').append(sidebar);
        else anchor.after(sidebar);
        trigger.hidden = !mobile.matches;
        syncHint();
      }
      function open() {
        if (!mobile.matches || dialog.open) return;
        dialog.showModal();
        hintSeen = true;
        try { sessionStorage.setItem(hintKey, '1'); } catch { /* The current page still remembers the dismissal. */ }
        syncHint();
      }
      function close(event) {
        if (event.target.closest('[data-filters-close]')) dialog.close();
        if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }
      }
      function restoreFocus() { if (mobile.matches) trigger.focus({ preventScroll: true }); }
      trigger.addEventListener('click', open);
      dialog.addEventListener('click', close);
      dialog.addEventListener('close', restoreFocus);
      mobile.addEventListener('change', sync);
      sync();
      instances.set(dialog, () => {
        mobile.removeEventListener('change', sync);
        dialog.removeEventListener('close', restoreFocus);
        if (dialog.open) dialog.close();
        trigger.removeEventListener('click', open);
        dialog.removeEventListener('click', close);
        if (home.isConnected) anchor.after(sidebar);
        anchor.remove();
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => instances.forEach((dispose, dialog) => {
    if (event.target.contains(dialog)) { dispose(); instances.delete(dialog); }
  }));
})();
